import { requireLoginModal } from "@liepin/react-login4c-pc";
import loginIsC from './login-is-c';

/*
 * 注意
 * 每个页面初始化时只能调一次（注意单页应用：放到router外）@张扬
 * 判断是否登录，未登录打开登录弹窗，登录成功后是否需要刷新页面@张扬
 */

window?.APP?.loadModule?.imc((im4c) => {
  im4c({
    beforeEntryChange: (isOpenIm) => {
      if (isOpenIm) {
        if (loginIsC()) {
          return true
        }
        requireLoginModal({
          onSuccess: () => {
            window.location.reload(true);
          }
        })
        return false
      }
      return true
    },
  });
});
